var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ButtonGroup',{ref:"editor",attrs:{"options":_vm.options,"propValue":_vm.propValue,"propReadonly":_vm.readonly},on:{"change":_vm.changeHandle,"afterChoose":_vm.afterChooseHandle,"selfClean":_vm.selfCleanHandle}})}
var staticRenderFns = []

export { render, staticRenderFns }